import { computed, inject, ComputedRef } from 'vue';

export function useBuilderMode() {
  const isAiTranslationMode = inject<ComputedRef<boolean>>('isAiTranslationMode', computed(() => false));
  const isManualTranslationMode = inject<ComputedRef<boolean>>('isManualTranslationMode', computed(() => false));
  const isTranslationMode = computed(() => isAiTranslationMode.value || isManualTranslationMode.value);

  return {
    isAiTranslationMode,
    isManualTranslationMode,
    isTranslationMode,
  };
}
